export default __webpack_public_path__ + "static/media/Untitled-2-01.e5a6b694.png";